<template>
  <button
    class="home-button text-gray-400 z-10"
    title="Go to homepage"
    @click="goHome"
  >
    <span class="home-button-sr">Go to homepage</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      class="home-button__icon"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      <polyline points="9,22 9,12 15,12 15,22"></polyline>
    </svg>
  </button>
</template>

<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

function goHome() {
  router.push("/");
}
</script>

<style scoped>
.home-button {
  display: inline-block;
  cursor: pointer;
}

.home-button-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.home-button:hover {
  color: #e472e1;
}
</style>
